module.exports = __webpack_public_path__ + "static/media/introduksjon-Ordforstaelse.128c7a58.mp3";